module.exports = __webpack_public_path__ + "images/subscribe-shard.svg";